import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';
import ListItemInfos from '../../../components/ListItem/Infos';
import DownloadManagerUtils from '../../../utils/downloadManager';
import { Api } from '../../../typings/api';
import DriveItemUtils from '../../../utils/driveItem';

export interface ListItemInfosOwnProps {
	itemId?: number;
	itemType?: Api.AssetType;
}

const mapStateToProps = (state: StoreState, ownProps: ListItemInfosOwnProps) => {
	const { downloadManager, driveList } = state;
	const { itemId } = ownProps;

	let isUpToDate = false;
	let isUpdatable = false;
	let isEmptyContextualMenu = false;
	let proposalStats: Api.ProposalData | undefined;
	let itemType: Api.AssetType | undefined;
	let publicationFormat: Api.PublicationFormat | undefined;
	let isDownloading = false;

	if (ownProps.itemType === Api.AdditionalItemType.Note) {
		return {
			itemType: Api.AdditionalItemType.Note,
			isUpToDate,
			isUpdatable,
			proposalStats,
			publicationFormat,
		};
	}

	if (itemId) {
		const driveItem = driveList.driveItems[itemId];
		itemType = driveItem.type;
		proposalStats = driveItem.proposalStats;
		publicationFormat = driveItem.format;
		const isDownloaded = DownloadManagerUtils.isItemPersistentlyDownloaded(downloadManager, itemId);

		if (isDownloaded) {
			const downloadedItem = downloadManager.items[itemId];

			isUpToDate = DriveItemUtils.isUpToDateWithDependencies(driveItem, downloadManager, downloadedItem.version);

			isUpdatable = !isUpToDate;
			isDownloading = DownloadManagerUtils.isItemDownloading(downloadManager, driveItem.id);
		}

		isEmptyContextualMenu = DriveItemUtils.isEmptyContextualMenu(driveItem, state);
	}

	return {
		itemType,
		isUpToDate,
		isUpdatable,
		proposalStats,
		publicationFormat,
		isEmptyContextualMenu,
		isDownloading,
	};
};

export default connect(mapStateToProps)(ListItemInfos);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ListItem/Infos/index.tsx